import React from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { Box, Typography } from '@mui/material';
import FormFooter from 'components/FormComponents/FormFooter';
import Modal from 'components/ModalV2';
import VerifyAccessLevel from 'components/VerifyAccessLevel';
import { adminTypes, IS_SANDBOX_ENV } from 'helper/constant';
import PropTypes from 'prop-types';

import { setShowModal } from 'redux/actions/billing';

import classes from './style.module.css';

function PaymentInfoModal({ paymentMethods, showModal, setShowModal, settingsValues, company }) {
    const location = useLocation();
    const history = useHistory();

    const { COMPANY_OWNER } = adminTypes;

    const platform = settingsValues?.find((setting) => setting.name === 'platform');
    const isShopify = platform?.value === 'SHOPIFY';

    const handleClose = () => {
        setShowModal(false);
    };

    const handleSubmitBtn = () => {
        history.push('/settings#billing' + location.search);
        setShowModal(false);
    };

    const accountStatus = company === 'approved' || company === 'revoked';

    // condition to check if panda doc document is signed
    const agreementSigned = company?.meta_data
        ? company?.meta_data.agreement_status === 'approved'
        : true;

    // TODO: After removing shopify from portal, this condition need to refactored
    // Show modal only if the user does not have the Shopify integration active. Never show it
    // in sandbox — sandbox accounts run on free credits and don't need a payment method.
    const show = showModal && !isShopify && !IS_SANDBOX_ENV && (accountStatus || agreementSigned);

    return (
        paymentMethods?.length === 0 && (
            <VerifyAccessLevel allowedAdmins={[COMPANY_OWNER]}>
                <Modal
                    open={show}
                    onClose={handleClose}
                    className={classes.paymentModalContainer}
                    disableBackdropClick
                >
                    <Box className={classes.innerContainer}>
                        <Box className={classes.headerContainer}>
                            <Typography className={classes.title}>Add Payment Method</Typography>
                            <Typography className={classes.bodyText}>
                                Please enter a payment method to activate your account. Adding a
                                payment method instantly authorizes an upfront, non-refundable
                                payment of your choosing or $100 if no amount is chosen. This is a
                                deposit for utilization credit. You draw down this credit balance
                                over time by utilizing our services. Your account auto-replenishes
                                when your remaining balance falls below $50.
                            </Typography>
                            <Typography className={classes.bodyText}>
                                <strong> All payments are non-refundable.</strong> If your balance
                                falls to $0 before the payment method on file can be charged, your
                                account will be suspended pending replenishment.
                            </Typography>
                            <Typography className={classes.bodyText}>
                                Please contact{' '}
                                <a href="mailto:support@authenticate.com">
                                    support@authenticate.com
                                </a>{' '}
                                to receive larger promotional credits for larger non-refundable
                                prepayments.
                            </Typography>
                        </Box>
                        <Box className={classes.btnContainer}>
                            <FormFooter
                                secondaryBtnText="Ask me later"
                                btnText="Okay"
                                formType="onClick"
                                secondaryBtnHandler={handleClose}
                                primaryBtnHandler={handleSubmitBtn}
                                secondaryClassName={classes.secondaryBtn}
                                primaryClassName={classes.primaryBtn}
                            />
                        </Box>
                    </Box>
                </Modal>
            </VerifyAccessLevel>
        )
    );
}

PaymentInfoModal.propTypes = {
    paymentMethods: PropTypes.array,
    showModal: PropTypes.bool,
    setShowModal: PropTypes.func,
    settingsValues: PropTypes.any,
    company: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        paymentMethods: state.billing.paymentMethods,
        showModal: state.billing.showModal,
        settingsValues: state.integration?.settingsValues,
        company: state.auth?.userData?.user?.company,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        setShowModal: (show) => dispatch(setShowModal(show)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentInfoModal);
